<template>
  <div
    class="main-content"
    :style="warpStyle"
  >
    <div class="login-form">
      <el-form
        ref="loginForm"
        :model="listQuery"
        :rules="loginRules"
        autocomplete="on"
        label-position="left"
        style="width: 100%"
      >
        <div class="login-form-header">
          <div class="form-header-title">
            Hello!
          </div>
          <div class="form-header-subtitle">
            欢迎来到{{ title }}！
          </div>
        </div>

        <el-form-item prop="username">
          <el-input
            v-model="listQuery.username"
            placeholder="请输入用户名"
            clearable
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="listQuery.password"
            placeholder="请输入登录密码"
            show-password
          />
        </el-form-item>

        <el-button
          class="login-btn"
          type="primary"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </el-form>
    </div>
    <!-- <img class="bg-icon" :src="bgIcon" /> -->
    <van-overlay
      :show="loading"
      @click="loading = false"
    >
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#1989fa"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { showPhoneAlarm, isWeiXin } from "@/global/function.js";
import { getSelf, wxLogin } from "@/api/user";
import checkPermission from "@/utils/permission";
import { title } from "@/config/settings";

export default {
  name: "Login",
  components: {},
  data() {
    const loginBg = require("@/assets/loginbg.png");
    return {
      loading: false,
      title,
      height: window.innerHeight + "px",
      listQuery: {
        username: "",
        password: "",
        token: "",
      },
      loginRules: {
        username: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 5 到 20 个字符",
          },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "用户名只能为英文及数字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 4,
            max: 25,
            message: "长度在 4 到 25个字符",
          },
          // {
          //   pattern: /^(\w){6,25}$/,
          //   message: "只能输入6-25个字母、数字、下划线",
          // },
        ],
      },
      redirect: undefined,
      bgIcon: require("@/assets/login-bg-icon.svg"),
      warpStyle: {
        height: window.innerHeight + "px",
        backgroundImage: `url('${loginBg}')`,
        backgroundSize: "100%",
        backgroundPosition: "bottom",
      },
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = (route.query && route.query.redirect) || "/";
      },
      immediate: true,
    },
  },
  async created() {
    const href = window.location.href;
    if (href.indexOf("code=") >= 0) {
      const search = location.search;
      const query = Object.assign(
        {},
        ...search
          .replace("?", "")
          .split("&")
          .map((param) => {
            const value = param.split("=");
            return { [value[0]]: value[1] };
          })
      );
      const { data } = await this.$store.dispatch("user/wxLogin", {
        code: query.code,
        wxtoken: "123",
      });
      const path = decodeURIComponent(
        location.hash.replace("#/login", "").replace("?redirect=", "")
      );
      console.log("data", data);
      if (+data.code === 2000) {
        const { data: selfData } = await getSelf();
        let personType = selfData.data.personType;
        this.$store.dispatch("user/loginSuccess", selfData).then((response) => {
          if (personType === 0 || personType === 3) {
            let path = "/dashboard/order";
            if (this.redirect.indexOf("material-check") !== -1) {
              path = this.redirect;
            }
            if (this.redirect.indexOf("self-weighing") !== -1) {
              path = this.redirect;
            }
            const newAddr = `${location.origin}${location.pathname}#${path}`;
            location.replace(newAddr);
          } else {
            const newAddr = `${location.origin}${location.pathname}#${
              path && path !== "/" ? path : "/dashboard"
            }`;
            location.replace(newAddr);
          }
        });
      } else if (+data.code === 4000) {
        this.$message({
          type: "info",
          message: data.msg || data.message,
        });
        console.log("data", data);
        this.listQuery.token = data.wxtoken;
      }
    } else {
      if (isWeiXin()) {
        let hash = encodeURIComponent(location.hash.replace("#", ""));
        location.href = [
          "https://open.weixin.qq.com/connect/oauth2/authorize?",
          "appid=wx3ceb0ecc06783683",
          "&response_type=code",
          "&scope=snsapi_userinfo",
          "&redirect_uri=" +
            encodeURIComponent(
              location.origin + location.pathname + location.hash
            ),
          "&state=" + hash + "#wechat_redirect",
        ].join("");
      }
    }
  },
  beforeCreate() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag === null) {
      const url = window.location.href;
      const baseUrl = url.substr(0, url.indexOf("/mobile"));
      const pcUrl = baseUrl + "/pc";
      window.location.href = pcUrl;
    }
  },
  methods: {
    checkPermission,
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          const payload = {
            username: this.listQuery.username,
            password: this.listQuery.password,
            wxtoken: this.listQuery.token,
          };
          const { data } = await this.$store.dispatch("user/login", payload);
          console.log("data", data);
          if (
            showPhoneAlarm(
              true,
              "toast",
              null,
              2000,
              data.code,
              "用户登录",
              data.msg ?? data.message
            )
          ) {
            const { data: selfData } = await getSelf();
            const path = decodeURIComponent(
              location.hash.replace("#/login", "").replace("?redirect=", "")
            );
            if (selfData.data.permission.length === 0) {
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                500,
                "",
                "权限不能为空"
              );
              return;
            }
            let personType = selfData.data.personType;
            this.$store
              .dispatch("user/loginSuccess", selfData)
              .then((response) => {
                if (personType === 0 || personType === 3) {
                  let path = "/dashboard/order";
                  if (this.redirect.indexOf("material-check") !== -1) {
                    path = this.redirect;
                  }
                  if (this.redirect.indexOf("self-weighing") !== -1) {
                    path = this.redirect;
                  }
                  const newAddr = `${location.origin}${location.pathname}#${path}`;
                  location.replace(newAddr);
                } else {
                  const newAddr = `${location.origin}${location.pathname}#${
                    path && path !== "/" ? path : "/dashboard"
                  }`;
                  location.replace(newAddr);
                }
              });
          }
          if (typeof data.data === "undefined") {
            return;
          }
        } else {
          showPhoneAlarm(
            true,
            "toast",
            "success",
            2000,
            200,
            "用户登录",
            "用户名或密码错误"
          );
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-content {
  font-size: 0.4rem;
  background-color: #183b79;
  overflow-x: hidden;
  overflow-y: hidden;

  .bg-icon {
    position: fixed;
    width: 100%;
    bottom: 0;
    padding: 10px;
  }

  .login-form {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .login-form-header {
      color: #ffffff;
      margin-bottom: 30px;
      .form-header-title {
        font-size: 30px;
        margin-bottom: 6px;
      }
      .form-header-subtitle {
        font-size: 18px;
      }
    }

    .login-btn {
      width: 100%;
      margin-top: 30px;
      font-size: 18px;
      background-color: #f2bf41;
      color: #ffffff;
      border: 1px solid #f2bf41;
    }
  }
}
</style>
